export const errorCodes = {
    emailExist: "auth/email-already-in-use",
    invalidEmail: "auth/invalid-email",
    notAllowed: "auth/operation-not-allowed",
    weekPassword: "auth/weak-password",
    userNotFound: "auth/user-not-found",
    wrongPassword: "auth/wrong-password",
    userDisabled: "auth/user-disabled"
};
export const googleErrorCodes = {}